import { render, staticRenderFns } from "./MenuGroups.vue?vue&type=template&id=34ffe9ec&scoped=true&"
import script from "./MenuGroups.vue?vue&type=script&lang=js&"
export * from "./MenuGroups.vue?vue&type=script&lang=js&"
import style0 from "./MenuGroups.vue?vue&type=style&index=0&id=34ffe9ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ffe9ec",
  null
  
)

export default component.exports